

























import {
  Vue,
  Component,
  Prop,
  Emit,
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import * as RouteNames from "@/employee/route-names";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    Button
  }
})
export default class DeductibleTrackerFooter extends Vue {
  featureFlagStore = useFeatureFlagStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  hasMultiplePlanScopes: boolean;

  @Prop()
  planScope: string;

  get showHealthcareClaims () {
    return this.custodianSettingsStore.displayHealthcareClaims;
  }

  get showNewClaims (): boolean {
    return this.custodianSettingsStore.displayNewHealthcareExpenses;
  }

  @Emit("change-plan-scope")
  changeScope (event) {
    return event.target.value;
  }

  healthcareClaimsPath () {
    return this.showNewClaims
      ? { name: RouteNames.ViewClaims }
      : { name: RouteNames.HealthcareExpenseClaims };
  }
}

